import { getAuthorizationsTableColumns } from '../config';
import { useMemo } from 'react';

const useAuthorizationsTable = (onReasonClick: (reason: string) => void) => {
  const columns = useMemo(() => {
    return getAuthorizationsTableColumns(onReasonClick);
  }, [onReasonClick]);

  return {
    columns,
  };
};

export default useAuthorizationsTable;
